'use client'

import type { Prices } from 'product/types/Prices'
import { useEffect } from 'react'
import { usePricesStore } from '../../context/PricesProvider'

export const PricesDispatcher = ({ prices }: { readonly prices: Prices }) => {
	const { updatePrices } = usePricesStore()

	useEffect(() => {
		updatePrices(prices)
	}, [prices, updatePrices])

	return null
}
